"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _uiKit = require("@devsta/ui-kit");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function LabelChild(_ref) {
  var label = _ref.label,
      selectedLabels = _ref.selectedLabels,
      onSelectlabel = _ref.onSelectlabel;
  var text = label.label,
      color = label.color,
      id = label.id;
  var brightness = (0, _tinycolor.default)(color).getBrightness();
  var textColor = brightness > 126 ? 'black' : 'white';
  var isSelected = selectedLabels.some(function (selectedId) {
    return selectedId === id;
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "labels__content__label-container",
    key: id
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: onSelectlabel(id),
    className: "labels__content__label",
    style: {
      background: color,
      color: textColor
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "labels__content__label__text"
  }, isSelected ? /*#__PURE__*/_react.default.createElement("strong", null, text) : text), isSelected && /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "success",
    color: textColor,
    size: 15
  })));
}

function LabelsToChose(_ref2) {
  var labels = _ref2.labels,
      onLabelSelected = _ref2.onLabelSelected,
      selectedLabels = _ref2.selectedLabels;

  var onSelectlabel = function onSelectlabel(labelId) {
    return function () {
      var selectedIndex = selectedLabels.findIndex(function (selectedId) {
        return selectedId === labelId;
      });

      if (selectedIndex >= 0) {
        var newSelected = _toConsumableArray(selectedLabels);

        newSelected.splice(selectedIndex, 1);
        onLabelSelected(newSelected);
        return;
      }

      onLabelSelected([].concat(_toConsumableArray(selectedLabels), [labelId]));
    };
  };

  return /*#__PURE__*/_react.default.createElement(_uiKit.LabelWrapper, {
    label: "Manage Labels",
    divContainer: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bulk-actions__bulk-operation__label-wrapper"
  }, labels.map(function (label) {
    return /*#__PURE__*/_react.default.createElement(LabelChild, {
      key: label.id,
      label: label,
      selectedLabels: selectedLabels,
      onSelectlabel: onSelectlabel
    });
  })));
}

var _default = /*#__PURE__*/(0, _react.memo)(LabelsToChose);

exports.default = _default;